import { WhyChooseUs, HerbsSection } from "@/components/Sections";
import { Certifications, TrustStrip } from "@/components/Certifications";
import { Testimonials } from "@/components/Testimonials";

export function WhyUsPage() {
  return (
    <div data-testid="why-us-page">
      <TrustStrip />
      <WhyChooseUs />
    </div>
  );
}

export function HerbsPage() {
  return (
    <div data-testid="herbs-page">
      <HerbsSection />
    </div>
  );
}

export function CertificationsPage() {
  return (
    <div data-testid="certifications-page">
      <TrustStrip />
      <Certifications />
    </div>
  );
}

export function ReviewsPage() {
  return (
    <div data-testid="reviews-page">
      <Testimonials />
    </div>
  );
}
